import { render } from "./ItemInput.vue?vue&type=template&id=1c5fe3d5&scoped=true"
import script from "./ItemInput.vue?vue&type=script&lang=js"
export * from "./ItemInput.vue?vue&type=script&lang=js"

import "./ItemInput.vue?vue&type=style&index=0&id=1c5fe3d5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5fe3d5"]])

export default __exports__